function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 0c2.13 0 3.86 2.08 3.86 4.65s-1.73 4.64-3.86 4.64a3.45 3.45 0 01-1.55-.38 7.32 7.32 0 00.13-1.41v-.72a1.9 1.9 0 001.45.79c1.1 0 2.14-1.25 2.14-2.92s-1-2.93-2.14-2.93-2 1.08-2.13 2.59a6.36 6.36 0 00-1.29-1.83A3.84 3.84 0 0115.75 0zM8.5 3c2.13 0 3.86 2.08 3.86 4.65s-1.73 4.64-3.86 4.64-3.86-2.08-3.86-4.64S6.37 3 8.5 3zm15.32 9.63c1 2.95 0 4.64 0 4.64s-2.41.78-4.8 1.3L19.1 17l-.06-.2h.08l1.27-.31c.7-.19 1.4-.38 2.06-.58a5.5 5.5 0 00-.28-2.73c-.34-1-.57-1.66-.73-2-.37.18-.71.37-1.51.82h-.06c-.82.46-1.46.8-2 1.05l-.52-1.67c1.1-.5 2.33-1.3 3.42-1.81 1.7-.8 2.08.11 3.05 3.06zm-7.25 3c1 2.95 0 4.64 0 4.64S11.24 22 8.58 22 .33 20.27.33 20.27s-.75-2.88 0-4.64 1.86-3.55 3.94-3.06c1.47 1.06 3.05 2.29 4.18 2.29 1.34 0 3.38-1.49 5.08-2.29s2.07.11 3.04 3.06z",
  clipRule: "evenodd",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M-18-18h61v58h-61z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M0 0h25v22H0z"
})), /*#__PURE__*/React.createElement("style", null, "\n      .cls-2{fill:none}\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.75 0c2.13 0 3.86 2.08 3.86 4.65s-1.73 4.64-3.86 4.64a3.45 3.45 0 01-1.55-.38 7.32 7.32 0 00.13-1.41v-.72a1.9 1.9 0 001.45.79c1.1 0 2.14-1.25 2.14-2.92s-1-2.93-2.14-2.93-2 1.08-2.13 2.59a6.36 6.36 0 00-1.29-1.83A3.84 3.84 0 0115.75 0zM8.5 3c2.13 0 3.86 2.08 3.86 4.65s-1.73 4.64-3.86 4.64-3.86-2.08-3.86-4.64S6.37 3 8.5 3zm15.32 9.63c1 2.95 0 4.64 0 4.64s-2.41.78-4.8 1.3L19.1 17l-.06-.2h.08l1.27-.31c.7-.19 1.4-.38 2.06-.58h0a5.5 5.5 0 00-.28-2.73c-.34-1-.57-1.66-.73-2-.37.18-.71.37-1.51.82h-.06c-.82.46-1.46.8-2 1.05l-.52-1.67c1.1-.5 2.33-1.3 3.42-1.81 1.7-.8 2.08.11 3.05 3.06zm-7.25 3c1 2.95 0 4.64 0 4.64S11.24 22 8.58 22 .33 20.27.33 20.27s-.75-2.88 0-4.64 1.86-3.55 3.94-3.06c1.47 1.06 3.05 2.29 4.18 2.29 1.34 0 3.38-1.49 5.08-2.29s2.07.11 3.04 3.06z",
  stroke: "#1f3052",
  strokeMiterlimit: 10,
  strokeWidth: 3.45,
  fill: "none"
}))));

function SvgMenuUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24.25 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUsers);
export default __webpack_public_path__ + "static/media/menu-users.212d7974.svg";
export { ForwardRef as ReactComponent };